import type { RotateProps } from './interfaces';
import styles from './Rotate.module.scss';

const Rotate = ({ degrees, children }: RotateProps) => {
  return (
    <div className={styles.base} style={{ transform: `rotate(${degrees}deg)` }}>
      {children}
    </div>
  );
};

export default Rotate;
